import { useEffect, useState } from 'react';
import {
    Box,
    Container,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    Typography,
} from '@mui/material';
import { SCUIButton, SCUITextField } from '../../../../atomic/atoms';
import { useTranslation } from 'react-i18next';
import EmailTemplateBuilderCommand from '../../../../services/command/emailTemplateBuilder/EmailTemplateBuilderCommand.services';
import Swal from 'sweetalert2';
import { LocalizationManagementQuery } from '../../../../services/query';
import React from 'react';
import { useHistory } from 'react-router';
import { SearchableCountrySelect } from '../../components/SearchableCountrySelect';
import { ETBCT_SAVE, etbCls } from '../../emailTemplateBuilder.classes';

function SaveTemplateDrawer({ sectionKeyList }: any) {
    const { t } = useTranslation();
    let history = useHistory();
    const [languageList, setLanguageList] = useState<any>();
    const [selectedLanguage, setSelectedLanguage] = React.useState<any>('tr-TR');
    const [selectCountryName, setSelectCountryName] = React.useState<any>('TR');
    const [switchChecked, setSwitchChecked] = React.useState(false);

    let operatorId: any = GetOperatorId();
    const [formData, setFormData] = useState({
        keyword: '',
        name: '',
        subject: '',
        sections: sectionKeyList,
        createdBy: operatorId,
        languageCode: selectedLanguage,
        countryCode: selectCountryName,
        inclusiveSection: '',
    });

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            languageCode: selectedLanguage,
            countryCode: selectCountryName,
        }));
    }, [selectedLanguage, selectCountryName]);

    const handleChange = (name: string, value: any) => {
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    useEffect(() => {
        GetLanguageList();
    }, []);
    const GetLanguageList = async () => {
        let serviceResponse: any = await LocalizationManagementQuery.CultureList();
        setLanguageList(serviceResponse.data);
    };
    const handleSwitchChecked = () => {
        if (switchChecked) {
            setFormData({ ...formData, inclusiveSection: '' });
        }
        setSwitchChecked(!switchChecked);
    };
    const handleSaveButton = () => {
        if (
            formData.keyword === '' ||
            formData.name === '' ||
            formData.subject === '' ||
            formData.sections.length === 0
        ) {
            Swal.fire('Lütfen boş alan bırakmayınız');
            return;
        }
        formData.languageCode = selectedLanguage;
        formData.countryCode = selectCountryName;
        EmailTemplateBuilderCommand.CreateTemplate(formData).then(() => {
            Swal.fire(t('general.added'), ' ', 'success');
            setTimeout(() => {
                history.push('/emailTemplateBuilder/templateGallery');
            }, 2000);
        });
    };
    return (
        <Container sx={{ padding: 5 }} className={ETBCT_SAVE.shell}>
            <Typography className={ETBCT_SAVE.title} variant="h4" gutterBottom>
                <h1> {t('emailTemplateBuilder.saveTemplateDrawer')}</h1>
            </Typography>
            <Box className={ETBCT_SAVE.fieldsColumn}>
            <Box className={etbCls(ETBCT_SAVE.fieldKeyword, ETBCT_SAVE.inputTextfieldKeyword)} style={{ marginTop: '2rem' }}>
                <SCUITextField
                    fullWidth
                    placeholder={'Keyword'}
                    size={'m'}
                    variant={'outlined'}
                    value={formData.keyword}
                    stateName={'keyword'}
                    onChange={(e) => handleChange('keyword', e)}
                />
            </Box>
            <Box className={etbCls(ETBCT_SAVE.fieldName, ETBCT_SAVE.inputTextfieldName)} style={{ marginTop: '2rem' }}>
                <SCUITextField
                    fullWidth
                    placeholder={'Name'}
                    size={'m'}
                    variant={'outlined'}
                    value={formData.name}
                    stateName={'name'}
                    onChange={(e) => handleChange('name', e)}
                />
            </Box>
            <Box className={etbCls(ETBCT_SAVE.fieldSubject, ETBCT_SAVE.inputTextfieldSubject)} style={{ marginTop: '2rem' }}>
                <SCUITextField
                    fullWidth
                    placeholder={'Subject'}
                    size={'m'}
                    variant={'outlined'}
                    value={formData.subject}
                    stateName={'subject'}
                    onChange={(e) => handleChange('subject', e)}
                />
            </Box>
            <Box className={ETBCT_SAVE.fieldInclusiveToggle} style={{ marginTop: '2rem' }}>
                <FormControlLabel
                    control={
                        <Switch checked={switchChecked} onChange={() => handleSwitchChecked()} name="switchChecked" />
                    }
                    label="Inclusive Section Ekle"
                />
                {switchChecked && (
                    <Box className={etbCls(ETBCT_SAVE.fieldInclusiveSection, ETBCT_SAVE.inputTextfieldInclusiveSection)}>
                    <SCUITextField
                        fullWidth
                        placeholder={'InclusiveSection'}
                        size={'m'}
                        variant={'outlined'}
                        value={formData.inclusiveSection}
                        stateName={'inclusiveSection'}
                        onChange={(e) => handleChange('inclusiveSection', e)}
                    />
                    </Box>
                )}
            </Box>
            {languageList && (
                <Grid
                    className={ETBCT_SAVE.fieldLanguage}
                    style={{ marginTop: '2rem' }}
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <FormControl style={{ width: 345 }}>
                        <InputLabel id="labelApp">{t('emailTemplateBuilder.selectLanguage')}</InputLabel>
                        <Select
                            className={ETBCT_SAVE.inputSelectLanguage}
                            label={t('emailTemplateBuilder.selectLanguage')}
                            labelId="labelApp"
                            id="parentMenuLabel"
                            value={selectedLanguage ? selectedLanguage : 'tr-TR'}
                            onChange={(event) => {
                                setSelectedLanguage(event.target.value);
                            }}
                            fullWidth
                        >
                            {languageList &&
                                languageList.map((language: any) => (
                                    <MenuItem key={language.code} id={language.id} value={language.code}>
                                        {language.code}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
            )}
            <Grid
                className={ETBCT_SAVE.fieldCountry}
                style={{ marginTop: '2rem' }}
                size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                }}
            >
                <SearchableCountrySelect
                    value={selectCountryName}
                    onChange={setSelectCountryName}
                    fullWidth={false}
                    style={{ width: 345 }}
                />
            </Grid>
            <Box className={ETBCT_SAVE.actionsRow} style={{ marginTop: '2rem' }}>
                <SCUIButton
                    className={ETBCT_SAVE.inputButtonSave}
                    type={'primary'}
                    sizeType={'fixed'}
                    size={'s'}
                    text={t('general.save')}
                    onClick={handleSaveButton}
                ></SCUIButton>
            </Box>
            </Box>
        </Container>
    );
}
export default SaveTemplateDrawer;

function GetOperatorId() {
    return JSON.parse(localStorage.getItem('checkOperator') || '{}').operatorId;
}
